import React from 'react'
import MasterLayout from "../masterLayout/MasterLayout";
import AddNonInventoryItemLayer from '../components/AddNonInventoryItemLayer';


export const AddNonInventoryItemPage = () => {
  return (
<>

      {/* MasterLayout */}
      <MasterLayout>

<AddNonInventoryItemLayer   />
      </MasterLayout>
</>  )
}
